/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn], [data-update-bulk-qty]');
    this.cartElement = document.querySelector('cart-form');   
    // this.qtyinput = this.querySelector('[data-qty-input]');

    if(this.form.getAttribute('data-format') == 'product-page' || this.form.getAttribute('data-format') == 'quickshop'){
      this.restrictProduct();
    }
  }

  restrictProduct(){
    if(this.form.querySelector('#producttags')){
      let productTags = (this.form.querySelector('#producttags').getAttribute('data-tags')).split(',');
      if(productTags.includes(Utility.getCookie('websiteType'))){
  
      }else{
        if(this.form.closest('.product-details-wrapper').querySelector('.price-wrapper')) this.form.closest('.product-details-wrapper').querySelector('.price-wrapper').classList.add('d-none');
        if(this.form.querySelector('[data-add-div]')) this.form.querySelector('[data-add-div]').classList.add('d-none');
        // if(this.form.querySelector('[data-main-buy-more]')) this.form.querySelector('[data-main-buy-more]').classList.add('d-none');
        if(this.form.querySelector('.available-errormsg')) this.form.querySelector('.available-errormsg').classList.add('d-none');
        
      }


      productTags.forEach(tag => {
        if(tag.indexOf(Utility.getCookie('warehouseID')) > -1 && tag.indexOf('FQU') > -1){
          // let getMultiplies = tag.replace(`UOM_${Utility.getCookie('warehouseID')}_`,'');
          let getMultiplies = tag.split('_').pop()
          this.form.querySelector('[data-qty-input]')?.setAttribute('data-fqu',getMultiplies);
          this.form.insertAdjacentHTML(
            'beforeend', 
            `<input data-fqu-input type="hidden" name="properties[_fqu]" value="${getMultiplies}">`);
            if(this.form.querySelector('[data-qty-input]')) {
              this.form.querySelector('[data-qty-input]').value = `${getMultiplies}`;
            }
        }
      });
    }
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
      // this.qtyinput.addEventListener('keyup', this.manageQtyBtn.bind(this));
    }else if(this.querySelector('[data-b2b-qty-container]')){
      // this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
  }

  
  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(serializeForm(this.form)));

    const body = JSON.stringify({
      items: addItems,
      sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header` 
    });
    
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
      }

      if(document.querySelector('#PopupModal-quickshop')){
        document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
      }
      if(qtyInput){
        if(qtyInput.getAttribute('data-fqu')){
          qtyInput.value = qtyInput.getAttribute('data-fqu');
        }else{
          qtyInput.value = 1;
        }
      } 

      if(this.cartElement){
        this.cartElement._updateCart(dataJSON.sections, 'open_drawer','updateCart');
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }    
      
      
      
      
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
      console.error(e);
      Rollbar.error(`File: component-product-form.js, getting error on onSubmitHandler: ${e}`);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
      if(document.querySelector('[data-variantinventorypolicyJSON]')){
        let variantInventoryPolicy = document.querySelector('[data-variantinventorypolicyJSON]');
        let currentVariantInventoryPolicy = '';
        if (variantInventoryPolicy) {
          const scriptContent = variantInventoryPolicy.textContent || variantInventoryPolicy.innerText;
          const extractInventoryPolicy = new Function(`${scriptContent}; return variant_inventory_policy;`);
          const inventoryPolicyData = extractInventoryPolicy();
          if(inventoryPolicyData && inventoryPolicyData[this.form.querySelector('input[name="id"]').value]){
            currentVariantInventoryPolicy = inventoryPolicyData[this.form.querySelector('input[name="id"]').value];
          }
        }
        if(currentVariantInventoryPolicy != 'continue'){
          this.restrictForInventory(submitButton);
        }
      }else{
        this.restrictForInventory(submitButton);
      }
      
    });
  }

  restrictForInventory(submitButton){
    let totalQty = this.form.querySelector('button[type="submit"]').getAttribute('data-availableinventory') ? parseInt(this.form.querySelector('button[type="submit"]').getAttribute('data-availableinventory')) : 1000;
    if(window.globalVariables.cart.item_count > 0){
      let cartItems = window.globalVariables.cart.items;
      cartItems.forEach(item => {
        if(parseInt(this.form.querySelector('input[name="id"]').value) == parseInt(item.id)){
          let totalCartQty = item.quantity;
          // let totalCheckQuantity = totalQty - totalCartQty;
          if(totalCartQty >= totalQty){
            submitButton.setAttribute('disabled',true);
            if(this.form.querySelector('.incart-errormsg')){
              this.form.querySelector('.incart-errormsg').innerHTML = `<p class="fs-sm rounded text-danger">Please check product quantity in cart.</p>`;
              this.form.querySelector('.incart-errormsg').classList.remove('d-none');
            } 
          }

          if(this.form.querySelector('[data-qty-input]').getAttribute('data-fqu')){
            let fquValue = this.form.querySelector('[data-qty-input]').getAttribute('data-fqu');
            let total = item.quantity + parseInt(fquValue);
            if(total > parseInt(this.form.querySelector('button[type="submit"]').getAttribute('data-availableinventory'))){
              
              this.form.querySelector('button[type="submit"]').setAttribute('disabled',true)
              // this.form.querySelector('button[type="submit"]').classList.add('loading')
              console.log('check','1');

              if(this.form.querySelector('.incart-errormsg')){
                this.form.querySelector('.incart-errormsg').innerHTML = `<p class="fs-sm rounded text-danger">Please check product quantity in cart.</p>`;
                this.form.querySelector('.incart-errormsg').classList.remove('d-none');
              } 
            }
          }

        }
      });
    }
  }

  restrictForInventoryOnQtyChange(updatedQuantity, target){
    let totalQty = this.form.querySelector('button[type="submit"]').getAttribute('data-availableinventory') ? parseInt(this.form.querySelector('button[type="submit"]').getAttribute('data-availableinventory')) : 1000;
    
    let fquqty = this.form.querySelector('[data-qty-input]').getAttribute('data-fqu') ? this.form.querySelector('[data-qty-input]').getAttribute('data-fqu') : 1;

    if(window.globalVariables.cart.item_count > 0){
      let cartItems = window.globalVariables.cart.items;
      let quantityInput = target.closest('[data-qty-container]').querySelector('[data-qty-input]');
      cartItems.forEach(item => {
        if(parseInt(this.form.querySelector('input[name="id"]').value) == parseInt(item.id)){
          let totalCartQty = item.quantity;
          let totalCheckQuantity = totalQty - totalCartQty;
          if(updatedQuantity > totalCheckQuantity){
            target?.closest("[data-qty-container]")?.querySelector('[data-for="increase"]')?.classList.add('disabled');
            target?.closest("[data-qty-container]")?.querySelector('[data-for-bulk="increase"]')?.classList.add('disabled');
            this?.form?.querySelector('[type="submit"]')?.setAttribute('disabled',true);
            window.notificationEle.updateNotification('Quantity Update', `You can not update quantity more than ${totalQty}. To add more please decrease the quantity.`, {
              type: 'error',
              timeout: 5000
            });
            quantityInput.value = parseInt(updatedQuantity) - parseInt(fquqty);
          }else if(updatedQuantity === totalCheckQuantity){
            target?.closest("[data-qty-container]")?.querySelector('[data-for="increase"]')?.classList.add('disabled');
            target?.closest("[data-qty-container]")?.querySelector('[data-for-bulk="increase"]')?.classList.add('disabled');
            this.form.querySelector('[type="submit"]').removeAttribute('disabled');
          }else{
            this.form.querySelector('[type="submit"]').classList.remove('disabled');
            this.form.querySelector('[type="submit"]').removeAttribute('disabled');
          }
        }else{
          if(updatedQuantity > totalQty){
            target?.closest("[data-qty-container]")?.querySelector('[data-for="increase"]')?.classList.add('disabled');
            target?.closest("[data-qty-container]")?.querySelector('[data-for-bulk="increase"]')?.classList.add('disabled');
            this.form.querySelector('[type="submit"]').setAttribute('disabled',true);
            window.notificationEle.updateNotification('Quantity Update', `You can not update quantity more than ${totalQty}. To add more please decrease the quantity.`, {
              type: 'error',
              timeout: 5000
            });
          }else if(updatedQuantity === totalQty){
            target?.closest("[data-qty-container]")?.querySelector('[data-for="increase"]')?.classList.add('disabled');
            target?.closest("[data-qty-container]")?.querySelector('[data-for-bulk="increase"]')?.classList.add('disabled');
            this.form.querySelector('[type="submit"]').removeAttribute('disabled');
          }else{
            this.form.querySelector('[type="submit"]').classList.remove('disabled');
            this.form.querySelector('[type="submit"]').removeAttribute('disabled');
          }
        }
      });
    }else{
      if(updatedQuantity > totalQty){
        target?.closest("[data-qty-container]")?.querySelector('[data-for="increase"]')?.classList.add('disabled');
        target?.closest("[data-qty-container]")?.querySelector('[data-for-bulk="increase"]')?.classList.add('disabled');
        this.form.querySelector('[type="submit"]').setAttribute('disabled',true);
        window.notificationEle.updateNotification('Quantity Update', `You can not update quantity more than ${totalQty}. To add more please decrease the quantity.`, {
          type: 'error',
          timeout: 5000
        });
      }else if(updatedQuantity === totalQty){
        target?.closest("[data-qty-container]")?.querySelector('[data-for="increase"]')?.classList.add('disabled');
        target?.closest("[data-qty-container]")?.querySelector('[data-for-bulk="increase"]')?.classList.add('disabled');
        this.form.querySelector('[type="submit"]').removeAttribute('disabled');
      }else{
        this.form.querySelector('[type="submit"]').classList.remove('disabled');
        this.form.querySelector('[type="submit"]').removeAttribute('disabled');
      }
    }
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    // console.log('manageQtyBtn');
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');
    let increaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="increase"]');

    let increaseBulkQtyBtn = event.currentTarget.closest('[data-qty-container]').querySelector('[data-for-bulk="increase"]');
    let decreaseBulkQtyBtn = event.currentTarget.closest('[data-qty-container]').querySelector('[data-for-bulk="decrease"]');

    let data_qty_bulk_number = 1;
    let data_qty_index = 1;

    let incQty = 1;
    if($qtyInput.getAttribute('data-fqu')){
      incQty = parseInt($qtyInput.getAttribute('data-fqu'));
    }

    if($qtyInput.getAttribute('data-qty-index')){
      data_qty_index = parseInt($qtyInput.getAttribute('data-qty-index'));
    }
    if($qtyInput.getAttribute('data-qty-bulk-number')){
      data_qty_bulk_number = parseInt($qtyInput.getAttribute('data-qty-bulk-number'));
    }

    if((action == 'decrease' || event.currentTarget.dataset.forBulk == 'decrease') && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      if(decreaseBulkQtyBtn) decreaseBulkQtyBtn.classList.add('disabled');
      increaseQtyBtn?.classList.remove('disabled');
      increaseBulkQtyBtn?.classList.remove('disabled');
      return false;
    }else if(action == 'decrease' || event.currentTarget.dataset.forBulk == 'decrease'){
      if (event.currentTarget.dataset.forBulk == 'decrease') {
        finalQty = currentQty - data_qty_bulk_number;

        // Ensure finalQty is a multiple of FQU
        finalQty = Math.round(finalQty / incQty) * incQty;
        finalQty = Math.max(finalQty, incQty);
      } else {
        finalQty = currentQty - incQty;
      }
      
      finalQty == incQty ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
      finalQty == incQty ? decreaseBulkQtyBtn.classList.add('disabled') : decreaseBulkQtyBtn.classList.remove('disabled');
      increaseQtyBtn?.classList.remove('disabled');
      increaseBulkQtyBtn?.classList.remove('disabled');
      if($qtyInput.getAttribute('data-qty-index')){
        $qtyInput.setAttribute('data-qty-index', (data_qty_index - 1));
      }
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      if(decreaseBulkQtyBtn) decreaseBulkQtyBtn.classList.remove('disabled');

      if (event.currentTarget.dataset.forBulk == 'increase') {
        finalQty = currentQty + data_qty_bulk_number;

        // Ensure finalQty is a multiple of FQU
        finalQty = Math.round(finalQty / incQty) * incQty;
        finalQty = Math.max(finalQty, incQty);
      } else {
        finalQty = currentQty + incQty;
      }

      if($qtyInput.getAttribute('data-qty-index')){
        $qtyInput.setAttribute('data-qty-index', (data_qty_index + 1));
      }
    }

    // this.manageUOM(finalQty,currentTarget,$qtyInput);

    $qtyInput.value = finalQty;

    // Get current variant from the VariantSelects instance
    let variantSelectsElement = this.form.querySelector('variant-selects, variant-radios');
    let currentVariant = variantSelectsElement ? variantSelectsElement.currentVariant : null;
    // console.log('currentVariant', currentVariant);
    
    let variantInventoryPolicy = document.querySelector('[data-variantinventorypolicyJSON]');
    let currentVariantInventoryPolicy = '';
    if (variantInventoryPolicy && currentVariant) {
      const scriptContent = variantInventoryPolicy.textContent || variantInventoryPolicy.innerText;
      const extractInventoryPolicy = new Function(`${scriptContent}; return variant_inventory_policy;`);
      const inventoryPolicyData = extractInventoryPolicy();
      if (inventoryPolicyData && inventoryPolicyData[currentVariant.id]) {
        currentVariantInventoryPolicy = inventoryPolicyData[currentVariant.id];
      }
    }
    if(currentVariantInventoryPolicy != 'continue'){
      this.restrictForInventoryOnQtyChange(finalQty,currentTarget);
    }

    
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;

    if (this.variant_json) {
      this.Json_attribute = this.variant_json.getAttribute("thumbs-imgs");
    }
  }

  connectedCallback() {
    // Element Connected callback
    if(this.formType == 'product-page' || this.formType == 'quickshop') this.onVariantChange('load');
    
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  restrictForInventory(){
    let cartItems = window.globalVariables.cart.items;
    cartItems.forEach(item => {
      if(this.form.querySelector('.incart-errormsg')){
      this.form.querySelector('.incart-errormsg').classList.add('d-none');
      }
      if(this.currentVariant.id == item.id){
        
        if(parseInt(item.quantity) >= parseInt(this.form.querySelector('button[type="submit"]').getAttribute('data-availableinventory'))){
          this.form.querySelector('button[type="submit"]').classList.add('disabled')
          // this.form.querySelector('button[type="submit"]').classList.add('loading')
          console.log('check','2');
          this.form.querySelector('button[type="submit"]').setAttribute('disabled',true)
          if(this.form.querySelector('.incart-errormsg')){
            this.form.querySelector('.incart-errormsg').innerHTML = `<p class="fs-sm rounded text-danger">Please check product quantity in cart.</p>`;
            this.form.querySelector('.incart-errormsg').classList.remove('d-none');
          } 
        }else{
          this.form.querySelector('button[type="submit"]').classList.remove('disabled')
          this.form.querySelector('button[type="submit"]').removeAttribute('disabled')
          // this.form.querySelector('button[type="submit"]').classList.remove('loading')
          console.log('check','3');
        }

        if(this.form.querySelector('[data-qty-input]').getAttribute('data-fqu')){
          let fquValue = this.form.querySelector('[data-qty-input]').getAttribute('data-fqu');
          let total = item.quantity + parseInt(fquValue);
          if(total > parseInt(this.form.querySelector('button[type="submit"]').getAttribute('data-availableinventory'))){
            this.form.querySelector('button[type="submit"]').classList.add('disabled')
            this.form.querySelector('button[type="submit"]').setAttribute('disabled',true)
            // this.form.querySelector('button[type="submit"]').classList.add('loading')
            if(this.form.querySelector('.incart-errormsg')){
              document.querySelector('.incart-errormsg').innerHTML = `<p class="fs-sm rounded text-danger">Please check product quantity in cart.</p>`;
              document.querySelector('.incart-errormsg').classList.remove('d-none');
              setTimeout(function(){
                document.querySelector('.incart-errormsg').classList.remove('d-none');
              },100)
            } 
          }else{
            this.form.querySelector('button[type="submit"]').classList.remove('disabled')
            this.form.querySelector('button[type="submit"]').removeAttribute('disabled')
            // this.form.querySelector('button[type="submit"]').classList.remove('loading')
          }
        }
      }
    });
  }


  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {

    // alert('hi')
    this.setCurrentVariant();
    this.variantData = this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    this.updateVariantStatuses();
    
    if(this.formType == 'product-page' || this.formType == 'quickshop') window.globalVariables.product.currentVariant = this.currentVariant;
    document.dispatchEvent(new Event('variant:changed'));

    this.form = this.form;
    
    console.log('currentVariant', this.currentVariant);
    if (!this.currentVariant) {
      // console.log('hereeeee');
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
    } else {
      // dltest

      let variantInventoryPolicy = document.querySelector('[data-variantinventorypolicyJSON]');
      // Get inventory policy for current variant from the script tag
      let currentVariantInventoryPolicy = '';
      if (variantInventoryPolicy) {
        // Extract the script content and evaluate it to get the variant_inventory_policy object
        const scriptContent = variantInventoryPolicy.textContent || variantInventoryPolicy.innerText;
        // Create a function to safely evaluate the script content
        const extractInventoryPolicy = new Function(`${scriptContent}; return variant_inventory_policy;`);
        const inventoryPolicyData = extractInventoryPolicy();
        
        // Get the inventory policy for the current variant
        if (inventoryPolicyData && inventoryPolicyData[this.currentVariant.id]) {
          currentVariantInventoryPolicy = inventoryPolicyData[this.currentVariant.id];
          // console.log('Current variant inventory policy:', currentVariantInventoryPolicy);
        }
      }

      if(this.form.querySelector('#checkForInventory').getAttribute('data-inventory_management') == 'shopify'){
        if(Utility.getCookie('locationID') != ''){

          if(this.form.querySelector('[data-qty-input]')){
            this.qtyinput = this.form.querySelector('[data-qty-input]');
            if(this.qtyinput.hasAttribute('data-fqu')){
              let fqu = this.qtyinput.getAttribute('data-fqu');
              this.qtyinput.value = fqu;
            }

            this.form.querySelector('.quantity-wrapper [data-for="increase"]').classList.remove('disabled');
          }

          let locationID = Utility.getCookie('locationID');
          let variantId = this.currentVariant.id;
          let requestData = { 
            variant_id: variantId,  
            location_id: locationID
          };
      
          console.log('requestData', requestData,currentVariantInventoryPolicy);

          fetch("https://shopifyapi2.jinny.com/api/fetch-inventory", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify(requestData),
          }).then(response => {
            return response.json();
          }).then(response => {
            let availableQty = response.available;
            console.log('availableQty', availableQty);
            this.form = this.form;
            

            this.qtyinput = this.form.querySelector('[data-qty-input]');
            if(this.form.querySelector('button[type="submit"]')){
              this.form.querySelector('button[type="submit"]').setAttribute('data-availableinventory',availableQty);
            }
            
            if(this.qtyinput){
              this.qtyinput.setAttribute('data-availableinventory',availableQty);
            }
            if(this.form.querySelector('[data-available-input]')){
              this.form.querySelector('[data-available-input]').value = availableQty
              if(currentVariantInventoryPolicy != 'continue'){
                this.restrictForInventory();
              }
            }else{
              this.form.insertAdjacentHTML(
                'beforeend', 
                `<input data-available-input type="hidden" name="properties[_availableinventory]" value="${availableQty}">`);
              }
            
            if(availableQty > 0){
              this.form.querySelector('button[type="submit"]').removeAttribute('disabled');
              this.form.querySelector('button[type="submit"]').classList.remove('disabled');
              // this.form.querySelector('button[type="submit"]').classList.add('loading')
              // this.form.querySelector('button[type="submit"]').classList.remove('loading')
              document.querySelector('.available-errormsg').innerHTML = `You can add ${availableQty} quantities to cart.`;
              document.querySelector('.available-errormsg').classList.remove('d-none');

              // document.querySelector('[data-main-buy-more]').classList.remove('d-none')

              if(this.form.querySelector('#producttags')){
                let productTags = (this.form.querySelector('#producttags').getAttribute('data-tags')).split(',');
                if(productTags.includes(Utility.getCookie('websiteType'))){
            
                }else{
                  if (document.querySelector('.available-errormsg')) {
                    document.querySelector('.available-errormsg').classList.add('d-none');
                  }
                }
              }
            }else if(currentVariantInventoryPolicy == 'continue'){
              console.log('currentVariantInventoryPolicy == continue','insider');
              this.form.querySelector('button[type="submit"]').removeAttribute('disabled');
              this.form.querySelector('button[type="submit"]').classList.remove('disabled');
              // this.form.querySelector('button[type="submit"]').classList.remove('loading')
              document.querySelector('.available-errormsg').classList.add('d-none');
              // document.querySelector('[data-main-buy-more]').classList.remove('d-none')
            }else{
              
              // document.querySelector('[data-main-buy-more]').classList.add('d-none')
              if(document.querySelector('.available-errormsg')){
                if(response.message){
                  this.form.querySelector('button[type="submit"] .add-text').textContent = 'Unavailable';
                }else{
                this.form.querySelector('button[type="submit"] .add-text').textContent = 'Out of stock';
                }
                this.form.querySelector('button[type="submit"]').setAttribute('disabled',true)
                // this.form.querySelector('button[type="submit"]').classList.add('loading')
                document.querySelector('.available-errormsg').innerHTML = '';
                document.querySelector('.available-errormsg').classList.add('d-none');
              }
            }
            if(currentVariantInventoryPolicy != 'continue'){
              this.restrictForInventory();
            }
            this.form.querySelector('button[type="submit"] .add-text').classList.remove('d-none')
          }).catch((e) => {
            console.error(e);
            // Rollbar.error(`File: component-product-form.js, getting error in fetch inventory on onVariantChange: ${e}`);
          })
        }
      }
      // code for update volume discount table
      if(document.querySelector('[data-main-buy-more]')){
        this.sectionID = 'template-product';
        let productHandle = this.form.querySelector('[name="product_handle"]').value;
        let productRoute = `https://www.jinny.com/products/${productHandle}?variant=${this.currentVariant.id}&sections=template-product`;
        fetch(productRoute).then(response => {
          return response.json();
        }).then(response => {
          let productHTML = response[this.sectionID];
          let parser = new DOMParser();
          productHTML = parser.parseFromString(productHTML, 'text/html');
          document.querySelector('[data-main-buy-more]').innerHTML = productHTML.querySelector('[data-buy-more-save-more]').innerHTML;
        }).catch((e) => {
            console.error(e);
            // Rollbar.error(`File: component-product-form.js, getting error on onVariantChange: ${e}`);
        }).finally(() => {
            
        });
      }
      // end code for update volume discount table

      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
        this.updateVariantFQU(this.currentVariant);
      }
      if(this.Json_attribute){
        this.manageImage(this.currentVariant);
      }else{
        if(document.querySelector('.product-thumb-slider')){
            document.querySelector('.product-thumb-slider').style.opacity = 1 ;
        }
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');

      /** case qty and sales updates **/

      let showcasequantity = document.querySelector('[data-showcasequantity]') ?? null;
      let showcasequantityBelowQty = document.querySelector('[data-showcasequantitybelowqty]') ?? null;

      let itemsizevalue = document.querySelector('[data-itemsizevalue]') ?? null;

      // console.log('itemsizevalue',itemsizevalue)

      let showsalesunit = document.querySelector('[data-showsalesunit]') ?? null;
      let casequantityWrapper = document.querySelector('[data-casequantitywrapper]') ?? null;
      let casequantityBelowQtyWrapper = document.querySelector('[data-casequantitybelowqtywrapper]') ?? null;
      let salesunitWrapper = document.querySelector('[data-salesunitwrapper]') ?? null;
      
      // if(this.formType == 'quickshop'){
        const scriptTag = document.querySelector('[data-variantadditionalJSON]');

        // 2. Get its JavaScript code as a string
        const scriptContent = scriptTag.textContent || scriptTag.innerText;

        // 3. Safely evaluate the variable using `Function` constructor
        const extractVariable = new Function(`${scriptContent}; return case_quantity_sales_unit;`);
        const caseQuantityData = extractVariable();
        var case_quantity_sales_unit = caseQuantityData;
      // }

     
        let current_case_quantity_sales_unit = null;

        if (case_quantity_sales_unit) {
          current_case_quantity_sales_unit = case_quantity_sales_unit[this.currentVariant.id] ?? null;
        }

        if (current_case_quantity_sales_unit) {
          if (showcasequantity && current_case_quantity_sales_unit.case_quantity != '') {
            showcasequantity.innerHTML = current_case_quantity_sales_unit.case_quantity;
            casequantityWrapper?.classList.remove('d-none');
          } else {
            casequantityWrapper?.classList.add('d-none');
          }
          if (showsalesunit && current_case_quantity_sales_unit.sales_unit != '') {
            showsalesunit.innerHTML = current_case_quantity_sales_unit.sales_unit;
            salesunitWrapper?.classList.remove('d-none');
          } else {
            salesunitWrapper?.classList.add('d-none');
          }
          if (showcasequantityBelowQty && current_case_quantity_sales_unit.case_quantity != '') {
            showcasequantityBelowQty.innerHTML = current_case_quantity_sales_unit.case_quantity;
            casequantityBelowQtyWrapper?.classList.remove('d-none');
          } else {
            casequantityBelowQtyWrapper?.classList.add('d-none');
          }

          
          // console.log('itemsizevalue',itemsizevalue,current_case_quantity_sales_unit.item_size)
          if (itemsizevalue && current_case_quantity_sales_unit.item_size != '') {
            if(itemsizevalue){
              itemsizevalue.innerHTML = current_case_quantity_sales_unit.item_size;
            }
          } else {
            // casequantityBelowQtyWrapper?.classList.add('d-none');
          }
          
        }
      // }
      /** case qty and sales updates END **/
    }

    if(this.formType == 'product-page' || this.formType == 'quickshop') {
      this.updateSaleAndDiscontinuedBadge(this.currentVariant);
    }
  }

  areAllValuesInSecondArray(array1, array2) {
    return array1.every(value => array2.includes(value));
  }

  manageImage(currentVariant){
    // console.log('manageImage==>');
    
    const featured_image = currentVariant.featured_media.id || null;

    this.variantName = (currentVariant.title.toLowerCase()).split(' / ');
    this.closestCont = this.closest('[data-product-container]');
    this.ShadeImagesParent = (this.formType == 'quickshop') ? this.closest('[data-product-container]').querySelector('.product-thumbnails-qv') : this.closest('[data-product-container]').querySelector('.product-thumbnails');
    let countSlides = 0;
    let arrayOfImageIndex = [];
    if(this.ShadeImagesParent){
      this.ShadeImages = this.ShadeImagesParent.querySelectorAll('.swiper-slide');
      this.ShadeImages.forEach((ele,index) => {
      let countedFlag = false;
      if(ele.querySelector('img')){
        let flag = ele.querySelector('img').alt.toLowerCase().split('&&');
        if (this.areAllValuesInSecondArray(flag, this.variantName)) {
          ele.style.display = "block";
          countSlides++;
          countedFlag = true;
          arrayOfImageIndex.push(index);
        }
        else if (flag[0] == "all") {
          ele.style.display = "block";
          countSlides++;
          countedFlag = true;
          arrayOfImageIndex.push(index);
        }
        else {
          ele.style.display = "none";
        }
        if(featured_image != null){
          if(featured_image == parseInt(ele.getAttribute('data-mediaid'))){
            ele.style.display = "block";
            if(!countedFlag){
              countSlides++;
              arrayOfImageIndex.push(index);
            }
          }
        }
      }
      })
    }

    
    const productGrid = (this.formType == 'quickshop') ? this.closest('[data-product-container]').querySelector('.quickshop-main-slider-new') : this.closest('[data-product-container]').querySelector('.product-main-slider');
    
    this.ShadeImagesParentMain = (this.formType == 'quickshop') ? this.closest('[data-product-container]').querySelector('.quickshop-main-slider-new') : this.closest('[data-product-container]').querySelector('.product-main-slider');
    this.ShadeImagesMain = this.ShadeImagesParentMain.querySelectorAll('.swiper-slide');
    
    if(window.innerWidth < 991){
    this.ShadeImagesMain.forEach((ele,index) => {
      if(ele.querySelector('img')){
        let flag = ele.querySelector('img').alt.toLowerCase().split('&&');

        if (this.areAllValuesInSecondArray(flag, this.variantName)) {
          // arrayOfImageIndex.push(index);
          
          // if(this.formType != 'quickshop') {
            ele.classList.add('d-flex');
            ele.classList.remove('d-none');
          // }else{
          //   ele.style.display = "block";
            
          // }
        }
        else if (flag[0] == "all") {
          // arrayOfImageIndex.push(index);
          
          // if(this.formType != 'quickshop') {
            // ele.style.display = "block";
            ele.classList.add('d-flex');
            ele.classList.remove('d-none');
          // }else{
          //   ele.style.display = "block";
          // }
        }
        else {
          
          // if(this.formType != 'quickshop') {
            ele.classList.remove('d-flex');
            ele.classList.add('d-none');
          // }else{
          //   ele.style.display = "none";
          // }
        }

        if(featured_image != null){
          if(featured_image == parseInt(ele.getAttribute('data-mediaid'))){
            // if(this.formType != 'quickshop') {
              ele.classList.add('d-flex');
              ele.classList.remove('d-none');
            // }else{
            //   ele.style.display = "block";
            // }
            // arrayOfImageIndex.push(index);
          }
        }
      }
      
    })
    }

    // console.log('productSlider',productSlider);

    // console.log('arrayOfImageIndex',arrayOfImageIndex);

    // console.log('quickShopSlider',quickShopSlider);

    if(productSlider){
      productSlider.slideTo(arrayOfImageIndex[0], 0, false);
      productSlider.update();
    }
    if(quickShopSlider){
      quickShopSlider.slideTo(arrayOfImageIndex[0], 0, false);
      quickShopSlider.update();
    }
    // this.renderProductInfo(currentVariant, productGrid);
    // window.dispatchEvent(new Event('resize'));

    // let interval = setInterval(function () {
    //   if(countSlides >= 1){
    //     if(document.querySelector('.product-thumb-slider').style.opacity == 0){
         
    //       if(productSlider){
    //         productSlider.slideTo(arrayOfImageIndex[0], 0, false);
    //         // productSlider.update();
    //       }
    //       if(quickShopSlider){
    //         quickShopSlider.slideTo(arrayOfImageIndex[0], 0, false);
    //         // quickShopSlider.update();
    //       }
    //       window.dispatchEvent(new Event('resize'));
    //       console.log('hereeee');
    //       document.querySelector('.product-thumb-slider').style.opacity = 1 ;
    //       clearInterval(interval);
    //     }
    //   }
    // }, 700);

    setTimeout(function () {
      // console.log('countSlides',countSlides);
      if(countSlides > 1){
        if(document.querySelector('.product-thumb-slider')){
          document.querySelector('.product-thumb-slider').style.opacity = 1 ;
        }
      }else if(countSlides <= 1){
        if(document.querySelector('.product-thumb-slider')){
          document.querySelector('.product-thumb-slider').style.opacity = 0 ;
        }
      }
      
      if(productSlider){
        productSlider.slideTo(arrayOfImageIndex[0], 0, false);
        productSlider.update();
      }
      if(quickShopSlider){
        quickShopSlider.slideTo(arrayOfImageIndex[0], 0, false);
        quickShopSlider.update();
      }


      // let thumbSlider = null;
      // let sliderOptions = document.querySelector('.product-main-slider .swiper-slider').getAttribute('data-slider');
      // sliderOptions = JSON.parse(sliderOptions);

      // // Set up nav slider 
      // if(document.querySelector('.product-main-slider .swiper-slider').hasAttribute('data-nav')){
      //   thumbSlider = document.querySelector('.' + document.querySelector('.product-main-slider .swiper-slider').getAttribute('data-nav'));
      //   if(thumbSlider == null){
      //     return;
      //   }

      //   let thumbSliderOptions = thumbSlider.getAttribute('data-slider');
      //   thumbSliderOptions = JSON.parse(thumbSliderOptions);
      //   thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);

      //   sliderOptions.thumbs = {
      //     swiper: thumbSlider
      //   }
      // }

      // let sliderInstance = new Swiper(document.querySelector('.product-main-slider .swiper-slider'), sliderOptions);

      // let slider = new Swiper(productSlider);
      // slider.update();
      // window.dispatchEvent(new Event('resize'));
      // window.scrollBy(0, 1);
    }, 800)
    
  }

  // updateVariantStatuses() {
    
  //   const selectedOptionOneVariants = this.variantData.filter(
  //     (variant) => this.querySelector(':checked').value === variant.option1
  //   );
  //   const inputWrappers = [...this.querySelectorAll('.product-form__input')];

  //   inputWrappers.forEach((option, index) => {
  //     // if (index === 0) return;
  //     if (inputWrappers.length == 1) {
  //       const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
  //       const previousOptionSelected = inputWrappers[0].querySelector(':checked').value;
  //       const availableOptionInputsValue = selectedOptionOneVariants
  //         .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected);
  //       this.setInputAvailability(optionInputs, availableOptionInputsValue);
  //     } else {
  //       if (index == 0) return;
  //       const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
  //       const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
  //       const availableOptionInputsValue = selectedOptionOneVariants
  //         .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
  //         .map((variantOption) => variantOption[`option${index + 1}`]);
  //       this.setInputAvailability(optionInputs, availableOptionInputsValue);
  //     }
  //   }); 
  // }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.toggleAttribute('disabled', !availableElement)
        // element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }
  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = 'option'+option.dataset.optionindex;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
      label.innerHTML = this.currentVariant[labelID];
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {

    
      if (!currentVariant) return;

      // if(this.formType == 'product-page' || this.formType == 'quickshop') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

      if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

      const input = this.form.querySelector('input[name="id"]');
      input.value = currentVariant.id;
    
  }

  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(priceElement) priceElement.innerHTML = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);;
    if(comparePriceElement) {
      comparePriceElement.innerHTML = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
      if(currentVariant.compare_at_price == null || currentVariant.compare_at_price <= 0 || currentVariant.compare_at_price == currentVariant.price){
        comparePriceElement.classList.add('d-none');
      }else{
        comparePriceElement.classList.remove('d-none');
      }
    }
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;
   
    this.priceUpdate(currentVariant, container);
    this.updateOptionLabel(this.form); 

    
    this.form.closest('.product-details-wrapper').querySelector('[data-sku-product]').textContent = currentVariant.sku;


    const featured_image = currentVariant.featured_image || null;
    if(featured_image != null){
      if(this.formType == 'grid'){
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = currentVariant.featured_image.src;
        featuredImage.srcset = currentVariant.featured_image.src;
      }else{
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        if(this.formType == 'quickshop'){
          imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        }
        if(!imageSlide) return;
  
        let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
        if(this.formType == 'quickshop' && quickShopSlider){
          // quickShopSlider.slideTo(slideIndex, 0, false);
        }else if(productSlider){
          // productSlider.slideTo(slideIndex, 0, false);
        }
      }
    }
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;
    this.addBtn.querySelector('.add-text').classList.add('d-none');
    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      // this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }

  /**
   * Update variants FQU
   */
  updateVariantFQU(currentVariant){
    let currentVariantFquWrapper = this.form.querySelector(`#productfqu-${currentVariant.id}`) ?? null;
    let currentVariantFquData = '';
    let currentVarientFquFound = false;

    if (currentVariantFquWrapper) {
      currentVariantFquData = currentVariantFquWrapper.dataset.variantfqus ?? null;

      if (currentVariantFquData && currentVariantFquData != ''){
        let currentVariantFqu = currentVariantFquData.split(',');
        currentVariantFqu.forEach(fqu => {
          if(fqu.indexOf(Utility.getCookie('warehouseID')) > -1 && fqu.indexOf('FQU') > -1){
            currentVarientFquFound = true;
            let getMultiplies = fqu.split('_').pop();
            this.form.querySelector('[data-qty-input]').setAttribute('data-fqu',getMultiplies);
            if (this.form.querySelector('[name="properties[_fqu]"]')){
              this.form.querySelector('[name="properties[_fqu]"]').value = getMultiplies;
            } else {
              this.form.insertAdjacentHTML(
                'beforeend', 
                `<input data-fqu-input type="hidden" name="properties[_fqu]" value="${getMultiplies}">`);
            }
            this.form.querySelector('[data-qty-input]').value = `${getMultiplies}`;
          }
        });
      }
    }
    if (currentVarientFquFound == false) {
      this.updateVariantFquWithTag();
    }
  }


  /**
   * Update variants FQU with tag
   */
  updateVariantFquWithTag() {
    if(this.form.querySelector('#producttags')){
      let productTags = (this.form.querySelector('#producttags').getAttribute('data-tags')).split(',');
      let setFQU = 1;
      if(productTags.length > 0) {
        productTags.forEach(tag => {
          if(tag.indexOf(Utility.getCookie('warehouseID')) > -1 && tag.indexOf('FQU') > -1){
            let getMultiplies = tag.split('_').pop();
            setFQU = getMultiplies;
          }
        });
      }
      this.form.querySelector('[data-qty-input]')?.setAttribute('data-fqu', setFQU);
      if (this.form.querySelector('[name="properties[_fqu]"]')){
        this.form.querySelector('[name="properties[_fqu]"]').value = setFQU;
      } else {
        this.form.insertAdjacentHTML(
          'beforeend', 
          `<input data-fqu-input type="hidden" name="properties[_fqu]" value="${setFQU}">`);
      }
      if (this.form.querySelector('[data-qty-input]')) {
        this.form.querySelector('[data-qty-input]').value = `${setFQU}`;
      }
    }
  }

  /**
   * Update sale and discontinued badges
   */
  async updateSaleAndDiscontinuedBadge(currentVariant=null){
    let showOnSaleBadge = false;
    let productTags = '';
    let pdp_badge_on_sale = document.querySelector('.pdp-badge-on-sale');
    let pdp_badge_discontinued = document.querySelector('.pdp-badge-discontinued');
    let pdp_badge_newitem = document.querySelector('.pdp-badge-new-item');
    let currentVariantOnsaleWrapper = '';
    let currentVariantOnSaleData = '';
    let currentVariantOnSales = '';
    let OnsaleTags = '';

    let currentVariantDiscontinuedWrapper = '';
    let currentVariantDiscontinuedData = '';
    let currentVariantDiscontinues = '';
    let DiscontinuesTags = '';
    let showDiscontinueBadge = false;

    let currentVariantNewItemWrapper = '';
    let currentVariantNewItem = false;
    let showNewItemBadge = false;

    if(currentVariant) {
      if(currentVariant.id) {
        currentVariantOnsaleWrapper = this.form.querySelector(`#productonsale-${currentVariant.id}`) ?? null;
        currentVariantDiscontinuedWrapper = this.form.querySelector(`#productdiscontinued-${currentVariant.id}`) ?? null;
        currentVariantNewItemWrapper = this.form.querySelector(`#productnewitem-${currentVariant.id}`) ?? null;
      }
    }

    if(this.form.querySelector('#producttags') || currentVariantDiscontinuedWrapper){
      if(currentVariantDiscontinuedWrapper) {
        currentVariantDiscontinuedData = currentVariantDiscontinuedWrapper.dataset.variantdiscontinued ?? null;
      }

      if (currentVariantDiscontinuedData && currentVariantDiscontinuedData != ''){
        currentVariantDiscontinues = currentVariantDiscontinuedData.split(',');
      }

      productTags = (this.form.querySelector('#producttags').getAttribute('data-tags')).split(',');

      if (currentVariantDiscontinuedWrapper) {
        DiscontinuesTags = currentVariantDiscontinues ?? [];
      } else {
        DiscontinuesTags = productTags;
      }

      if (pdp_badge_discontinued && DiscontinuesTags.length > 0) {
        DiscontinuesTags.forEach(tag => {
          if(tag.indexOf(Utility.getCookie('warehouseID')) > -1 && tag.indexOf('blowout') > -1){
            let discontinuedLocation = tag.split('_').pop();
            showDiscontinueBadge = true;
          }
        });
      }

      if (pdp_badge_discontinued && showDiscontinueBadge == true) {
        pdp_badge_discontinued.classList.remove('d-none');
        if (this.form?.querySelector('button[type="submit"]')) {
          this.form.querySelector('button[type="submit"]').classList.add("discontinued_add_to_cart");
        }
      } else {
        pdp_badge_discontinued?.classList.add('d-none');
        if (this.form?.querySelector('button[type="submit"]')) {
          this.form.querySelector('button[type="submit"]').classList.remove("discontinued_add_to_cart");
        }
      }

      if(currentVariantNewItemWrapper) {
        currentVariantNewItem = currentVariantNewItemWrapper.dataset.variantnewitem ?? null;
      }

      if (currentVariantNewItemWrapper) {
        if (currentVariantNewItem && currentVariantNewItem != '' && currentVariantNewItem != false && currentVariantNewItem != 'false') {
          showNewItemBadge = true;
        }
      } else {
        if (pdp_badge_newitem && productTags.length > 0) {
          productTags.forEach(tag => {
            if(tag.indexOf('NEW_ITEM') > -1){
              showNewItemBadge = true;
            }
          });
        }
      }

      if (pdp_badge_newitem && showNewItemBadge == true) {
        pdp_badge_newitem.classList.remove('d-none');
      } else {
        pdp_badge_newitem?.classList.add('d-none');
      }
      
    }

    if (window.globalVariables.customer_id && window.globalVariables.customer_id != null && pdp_badge_on_sale) {
      let customer_id = window.globalVariables.customer_id;
      if (Utility.getCookie('cif_customerLocationData') === '') {
        try {
            const response = await fetch(`https://shopifyapi2.jinny.com/api/get-catalogs?customer_id=${customer_id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            });

            const data = await response.json();
            
            let allLocations = data.companyContactProfiles[0].company.locations.nodes;
            Utility.setCookie('cif_customerLocationData', JSON.stringify(allLocations), 7);
        } catch (error) {
            console.error(error);
        } finally {
            // fetch done
        }
      }

      let allLocationData = JSON.parse(Utility.getCookie('cif_customerLocationData'));
      if(currentVariantOnsaleWrapper) {
        currentVariantOnSaleData = currentVariantOnsaleWrapper.dataset.variantonsale ?? null;
      }

      if (currentVariantOnSaleData && currentVariantOnSaleData != ''){
        currentVariantOnSales = currentVariantOnSaleData.split(',');
      }

      productTags = (this.form.querySelector('#producttags').getAttribute('data-tags')).split(',');

      if (currentVariantOnsaleWrapper) {
        OnsaleTags = currentVariantOnSales ?? [];
      } else {
        OnsaleTags = productTags;
      }

      if(allLocationData.length > 0) {
        allLocationData.forEach((location) => {
          let currentAllLocId = [location.metafield?.value] ?? null;
          let selectedLocId = Utility.getCookie('warehouseID');
          let allCatalogs = location.catalogs.nodes;
          if (currentAllLocId?.includes(selectedLocId)) {
            allCatalogs.forEach((catalog) => {
              let catalogTitle = catalog.title;
              if (OnsaleTags.length > 0) {
                OnsaleTags.forEach(tag => {
                  if(tag.indexOf('ON_SALE') > -1){
                    let onSaleCatalogTitle = tag.split('ON_SALE_').pop();
                    if (onSaleCatalogTitle.indexOf(catalogTitle) > -1) {
                      showOnSaleBadge = true;
                    }
                  }
                });
              }
            })
          }
        })
      }

      if (pdp_badge_on_sale) {
        if(showOnSaleBadge == true || showOnSaleBadge == 'true' && showOnSaleBadge != '') {
          pdp_badge_on_sale.classList.remove('d-none');
        } else {
          pdp_badge_on_sale.classList.add('d-none');
        }
      }
    }

  }

}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);